import { ErrorCodeType } from '../constants/errorCodes';

export const bpErrorsCodes: Record<string, ErrorCodeType> = {
  chargeVoidFailed: {
    message: 'abp.charges.chargeVoidFailed',
  } as ErrorCodeType,
  chargeAlreadyVoided: {
    code: 'Current state: VOIDED',
    message: 'abp.charges.chargeAlreadyVoided',
  } as ErrorCodeType,
  chargeAlreadyPaid: {
    code: 'Invoice is already PAID',
    message: 'abp.charges.chargeAlreadyPaid',
  } as ErrorCodeType,
  invoiceAlreadyPaid: {
    code: 'Current state: PAID',
    message: 'abp.invoice.markAsPaidSuccessMessage',
  } as ErrorCodeType,
  invoiceNotIssued: {
    code: 'Current state: CHARGE_ADDED',
    message: 'abp.invoice.invoiceNotIssued',
  } as ErrorCodeType,
  subscriptionCancelledButNotUci: {
    code: 'BP-SUB-001',
    name: 'SubscriptionCancelledButNotUciError',
    message: 'abp.errors.subscription.subscriptionCreatedAndUciFailed',
  },
  chargeCodeUpdateError: {
    message: 'abp.charges.chargeCode.updateError',
  } as ErrorCodeType,
  chargeCodeUpdateRequestRequired: {
    message: 'abp.charges.chargeCode.requestRequired',
  } as ErrorCodeType,
  chargeCodeSourceRestrictionError: {
    code: 'BP-CHAR-001',
    name: 'ChargeCodeSourceRestrictionError',
    message: 'Only charge codes with source "ACTIVATE" can be deleted',
  } as ErrorCodeType,
  productCategoryAlreadyExistsError: {
    code: 'BP-PC-001',
    name: 'ProductCategoryAlreadyExistsError',
    message: 'abp.productsServices.editCategory.nameAlreadyExists',
  },
} as const;

export const bpGRPCErrorMessages = {
  statusUnavailable: {
    message: 'abp.errors.grpc.statusUnavailable',
  } as ErrorCodeType,
  statusInternal: {
    message: 'abp.errors.grpc.statusInternal',
  } as ErrorCodeType,
  statusNotFound: {
    message: 'abp.errors.grpc.statusNotFound',
  },
  statusDefaultError: {
    message: 'abp.errors.grpc.statusDefaultError',
  },
} as const;
